module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAS1BMVEUAAAD7VFT7Vlb7VVX7VVX7Vlb8VVX6VVX7VVX6VFT7Vlb/Vlb/W1v7VFT6VFT6VVX6VVX8VVX8Vlb9Vlb/WVn/amr7VVX7Vlb6VFQaTTghAAAAGHRSTlMAwHfksYBacPRpOiYO68+nn5JLMhsGuETTFKdwAAAAf0lEQVQ4y93SyQrDMAxF0eehrqfMSfv+/0u7MSYQW7tC2rO+CCGEm1oNu6ajRIYCVyJK9N9FXtmqc4LB4eRoRj5hm1XVnqQRefJsRhss1e7kKGOkRpajiJlDsHK0YDfCTsWK7B5VbEdcEq544U0VbvIF341GCt4lSpPqeQX8sg8qeT9/1BqWSgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w1.png
// module id = eECB
// module chunks = 1